import React, { useState, useEffect } from "react";
import moment from "moment/moment";
import "../offerprice/salehistory/index.css";

// components
import PaginationHelper from "../../components/PaginationHelper";
import AnimationLoading from "../../components/Animationloading";
import EmptyComponent from "../../components/EmptyComponent";

// apollo-client
import { GET_PRODUCTS, GET_PRODUCT_HISTORY } from "../../apollo/product/query";
import { useLazyQuery, useMutation } from "@apollo/client";

// Icons
import SearchIcon from "@mui/icons-material/Search";

// Bootrap
import { Form, Row, InputGroup, Col, Table } from "react-bootstrap";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import { LINEAR_GRADIENT_BG } from "../../const";
import { numberFormat } from "../../helper";
import CustomButton from "../../components/CustomButton";
import {
  DELETE_PRODUCT_FORM_DB,
  RECOVER_PRODUCT_OLD,
} from "../../apollo/product/Mutation";
import ComfirmModal from "../../components/ComfirmModal";
import { successDeleteSwal } from "../../helper/sweetalert";
import { MdAutorenew, MdDelete } from "react-icons/md";
import { Alert } from "antd";

export default function ProductDeleted() {
  const dateNow = new Date().toISOString().slice(0, 10);
  const [productHistory, setProductHistory] = useState();
  const [productDeleted, setProductDeleted] = useState([]);
  const [productDeletedTotal, setProductDeletedTotal] = useState([]);
  const [currentStartDate, setCurrentStartDate] = useState("2023-09-01");
  const [currentEndDate, setCurrentEndDate] = useState(dateNow);
  const [searchText, setSearchText] = useState("");
  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  const [openComfirmModal, setOpenComfirmModal] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [openRecoverComfirm, setOpenRecoverComfirm] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [dataForRetrun, setDataForRetrun] = useState([]);

  const [productPreId, setProductPreId] = useState("");
  let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

  // ============== > UseLazyQuery And UseMutaion <==============

  const [LoadProduct, { data: GetProductData, loading: loadingProduct }] =
    useLazyQuery(GET_PRODUCTS, { fetchPolicy: "network-only" });

  const [deleteProductFromDB, { loading: loadingDeleted }] = useMutation(
    DELETE_PRODUCT_FORM_DB
  );

  const [recoverProduct, { loading: loadingRecover }] =
    useMutation(RECOVER_PRODUCT_OLD);
  // ============== > useEffect <==============

  useEffect(() => {
    if (GetProductData) {
      setProductDeleted(GetProductData?.products?.data);
      setProductDeletedTotal(GetProductData?.products?.total);
    }
  }, [GetProductData]);

  //   console.log("result: ", getproducthistoryData);

  useEffect(() => {
    _filter();
    fetchProductDeleted();
  }, []);

  useEffect(() => {
    _filter();
  }, [searchText, currentStartDate, currentEndDate, _skip]);

  // ============== > fuctions <==============

  //   fetch product all
  const fetchProductDeleted = () => {
    LoadProduct({
      variables: {
        orderBy: "createdAt_DESC",
        skip: (_skip - 1) * _limit,
        limit: _limit,
        where: {
          shop: shopId,
          isDeleted: true,
        },
      },
    });
  };

  const _filter = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: true, // ສິນຄ້າທີ່ຖຶກລຶບແລ້ວ
      };
      // TODO: check if search text is not empty
      if (searchText !== "") {
        _where = {
          ..._where,
          name: searchText,
          //   barCode: searchText,
        };
      }
      //check if filter date is set
      if (currentStartDate && currentEndDate) {
        _where = {
          ..._where,
          createdAt_gte: new Date(
            moment(moment(currentStartDate).format("YYYY-MM-DD")).toISOString()
          ),
          createdAt_lt: new Date(
            moment(moment(currentEndDate).add(1, "days")).format("YYYY-MM-DD")
          ).toISOString(),
        };
      }

      // TODO: Get all order groups
      //   getproducthistory({
      //     variables: {
      //       where: _where,
      //       skip: (_skip - 1) * _limit,
      //       limit: 50,
      //       orderBy: "createdAt_DESC",
      //     },
      //   });

      LoadProduct({
        variables: {
          orderBy: "createdAt_DESC",
          skip: (_skip - 1) * _limit,
          limit: _limit,
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  //   deleted product from database
  const deletedProductFormDB = async () => {
    try {
      // console.log("dataFroRetrun------>", dataForRetrun)
      const _ids = await dataForRetrun.map((data) => data?.id);
      const req = await deleteProductFromDB({
        variables: {
          where: {
            id_in: _ids,
          },
        },
      });
      if (req) {
        successDeleteSwal("ສິນຄ້າຖຶກລົບອອກຈາກລະບົບແລ້ວ");
        setOpenComfirmModal(false);
        fetchProductDeleted();
        setDataForRetrun([]);
        setIsSelectAll(false);
        // setIsAlert(true)
      }
    } catch (error) {
      console.log("error:-->", error);
    }
  };

  //   recover product ------------>
  const handleRecoverProductOld = async () => {
    try {
      if (loadingRecover) return;
      const _ids = await dataForRetrun.map((data) => data?.id);
      await recoverProduct({
        variables: {
          where: {
            id_in: _ids,
          },
        },
      });
      setDataForRetrun([]);
      setOpenRecoverComfirm(false);
      successDeleteSwal("ກູ້ຄືນສຳເລັດແລ້ວ");
      fetchProductDeleted();
      setIsSelectAll(false);
      // setIsAlert(true)
    } catch (err) {
      console.log("error:", err);
    }
  };

  //   console.log("GetProductData====55555>", GetProductData);

  const handleChangeStartDate = (e) => {
    setCurrentStartDate(e?.target?.value);
  };

  const handleChangeEndDate = (e) => {
    setCurrentEndDate(e?.target?.value);
  };

  const handleDeleteProduct = (id) => {
    setProductPreId(id);
    setOpenComfirmModal(true);
  };

  //   select all items
  const handleSelectAllItems = () => {
    // console.log("order----->: ", ordergroupData?.orders);
    if (isSelectAll) {
      setIsSelectAll(false);
      setDataForRetrun([]);
    } else {
      // const _dataForReturn = ordergroupData?.orders.map((order) => order.id);
      setIsSelectAll(true);
      // console.log("returnOrderAll====>", _dataForReturn);
      setDataForRetrun(productDeleted);
    }
  };

  //   select single item
  const handleSelectSingleItems = (e) => {
    const orderId = e.id; // Replace 'id' with the actual property name

    setDataForRetrun((prevSelected) => {
      // Check if the item is already in the selectedItems array
      const isSelected = prevSelected.some((item) => item.id === orderId);

      // If it's selected, remove it; otherwise, add it to the selectedItems array
      if (isSelected) {
        return prevSelected.filter((item) => item.id !== orderId);
      } else {
        return [...prevSelected, e];
      }
    });
  };

  return (
    <React.Fragment>
      <div className="sale-history-mains">
        <BreadCrumbComponent
          // goback={() => history.goBack()}
          // txtFirst="ປະຫວັດການຂາຍ"
          txtSecond={`ຖັງຂີ້ເຫຍື້ອ`}
        />
        {/* {isAlert && <div style={{marginTop:'-1em',padding:'0 2em'}}>
          <Alert message="ກູ້ຄືນສະຕ໋ອກສຳເລັດແລ້ວ" closable  type="success" showIcon />
        </div>} */}

        <div style={{ padding: "1em 2em" }}>
          <h4>
            <b>ປະຫວັດການລົບສິນຄ້າ</b>
          </h4>
          <p>
            ສິນຄ້າທີ່ຖຶກລົບທັງໝົດ ຈະເກັບໄວ້ໃນລະບົບ ເພື່ອກວດຄືນ ປະຫວັດການລົບ.
          </p>
        </div>

        <div style={{ padding: "0 2em" }}>
          <Row>
            {/* <Col className="col-4"></Col> */}
            <Col className="col-8">
              <Form.Label htmlFor="basic-url">ຄົ້ນຫາ</Form.Label>
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{
                    backgroundColor: "#FFFFFF",
                  }}>
                  <SearchIcon sx={{ color: "#6B7280" }} />
                </InputGroup.Text>
                <Form.Control
                  id="basic-url"
                  onChange={(e) => {
                    setSearchText(e?.target?.value);
                  }}
                  value={searchText}
                  aria-describedby="basic-addon3"
                  placeholder="ປ້ອນຊື່ສິນຄ້າ"
                />
              </InputGroup>
            </Col>
            <Col className="col-4">
              <Form.Label>ຄົ້ນຫາລະຫວ່າງ ວັນທີ ກັບ ວັນທີ</Form.Label>
              <InputGroup className="mb-3">
                {/* <InputGroup.Text>First and last name</InputGroup.Text> */}
                <Form.Control
                  type="date"
                  value={currentStartDate}
                  onChange={(e) => handleChangeStartDate(e)}
                />
                <div
                  className=" p-2"
                  style={{
                    background: "#ffff",
                    borderTop: "1px solid #ddd",
                    borderBottom: "1px solid #ddd",
                  }}>
                  ຫາ
                </div>
                <Form.Control
                  type="date"
                  value={currentEndDate}
                  onChange={(e) => handleChangeEndDate(e)}
                />
              </InputGroup>
            </Col>
          </Row>
        </div>

        <div style={{ padding: "0 2em", marginTop: "-.5em" }}>
          {loadingProduct && !GetProductData ? (
            <AnimationLoading />
          ) : (
            <>
              {productDeleted?.length > 0 ? (
                <Table
                  hover
                  style={{
                    borderCollapse: "collapse",
                    width: "100% ",
                    background: "#fff",
                  }}>
                  <thead
                    style={{
                      background: LINEAR_GRADIENT_BG,
                      borderRadius: " 8px 8px 0px 0px",
                      color: "#FFFFFF",
                    }}>
                    <tr>
                      {/* <th>#</th> */}
                      {/* <th>ລ/ດ</th> */}
                      <th>
                        <Form.Check
                          inline
                          label="ລຳດັບ"
                          type="checkbox"
                          checked={isSelectAll}
                          onClick={() => handleSelectAllItems()}
                        />
                      </th>
                      <th>ລະຫັດບາໂຄດ</th>
                      <th>ປະເພດ</th>
                      <th>ຊື່ສິນຄ້າ</th>
                      <th>ຈຳນວນ</th>
                      <th>ຫົວໜ່ວຍ</th>
                      <th>ລາຄາ</th>
                      <th>ວັນທີ່, ເດືອນ, ປີ</th>
                      {/* <th>ຈັດການ</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {productDeleted?.map((product, index) => (
                      <tr className="saleRows">
                        <td>
                          {isSelectAll ? (
                            <Form.Check
                              inline
                              type="checkbox"
                              checked={true}
                              disabled
                            />
                          ) : (
                            <Form.Check
                              inline
                              type="checkbox"
                              onClick={() => handleSelectSingleItems(product)}
                              checked={dataForRetrun.includes(product)}
                            />
                          )}
                          {index + 1 + _limit * (_skip - 1)}
                        </td>
                        <td>{product?.barCode ?? "-"}</td>
                        <td>{product?.categoryName ?? "-"}</td>
                        <td>{product?.name ?? "-"}</td>
                        <td>{product?.amount ?? "-"}</td>
                        <td>
                          {product?.unit ?? product?.priceOptions?.unit ?? "-"}
                        </td>
                        <td>
                          {product?.price !== null
                            ? numberFormat(
                              product?.price ?? product?.priceOptions?.price
                            )
                            : "--"}{" "}
                          {product?.currency === "BAHT"
                            ? "THB"
                            : product?.currency}{" "}
                        </td>
                        <td>
                          {moment(product?.updatedAt).format("DD/MM/YYYY")}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div>
                  {productHistory?.length <= 0 && (
                    <div
                      style={{
                        fontSize: "24px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#6B7280",
                        fontWeight: "400",
                      }}>
                      <EmptyComponent />
                      <p>ຍັງບໍ່ມີປະຫວັດການເເກ້ໄຂສະຕອັກ !!!</p>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
        {productDeletedTotal > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "1em 2em",
            }}>
            {productDeletedTotal && (
              <div className="show">
                ກຳລັງສະແດງ {50 * _skip - 49}-
                {50 * _skip > productDeletedTotal
                  ? productDeletedTotal
                  : 50 * _skip}{" "}
                ຈາກ {productDeletedTotal}
              </div>
            )}
            <div>{Pagination_helper(productDeletedTotal, "", ``)}</div>
          </div>
        ) : (
          ""
        )}
      </div>

      {dataForRetrun?.length >= 1 && (
        <div className="card-action-deleted">
          <CustomButton
            width="150px"
            margin="0"
            title={"ກູ້ຄືນສິນຄ້າ"}
            padding={".5em 1em"}
            borderRadius="8px"
            background={LINEAR_GRADIENT_BG}
            color="#fff"
            icon={<MdAutorenew sx={{ fontSize: 20 }} />}
            onClick={() => setOpenRecoverComfirm(true)}
          />
          <CustomButton
            width="150px"
            margin="0"
            title={"ລືບອອກ"}
            padding={".5em 1em"}
            borderRadius="8px"
            background="#dc2626"
            color="#fff"
            icon={<MdDelete sx={{ fontSize: 20 }} />}
            onClick={() => setOpenComfirmModal(true)}
          />
        </div>
      )}

      <ComfirmModal
        showConfirmModal={openRecoverComfirm}
        handleCancel={() => setOpenRecoverComfirm(false)}
        // handleConfirm={_ReturnOrderGroup}
        handleConfirm={handleRecoverProductOld}
        loadingConfirm={loadingRecover}
        title="ແຈ້ງເຕືອນ"
        text="ຕ້ອງການກູ້ຄືນສິນຄ້າເຫຼົ່ານີ້ບໍ!"
      />

      <ComfirmModal
        showConfirmModal={openComfirmModal}
        handleCancel={() => setOpenComfirmModal(false)}
        // handleConfirm={_ReturnOrderGroup}
        handleConfirm={deletedProductFormDB}
        loadingConfirm={loadingDeleted}
        title="ແຈ້ງເຕືອນ"
        text="ທ່ານຕ້ອງການລືບສິນຄ້າທັງໝົດນີ້ບໍ!"
      />
    </React.Fragment>
  );
}
